// @flow
import * as React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Toolbar from '@material-ui/core/Toolbar';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import classnames from 'classnames';
import map from 'lodash/map';

import useSiteInfo from '~hooks/useSiteInfo';
import FieldLink from '~plugins/prismic/components/FieldLink';

import type { Props } from './types';
import styles from './styles';

const AppBar = ({
  toggleRightDrawer,
  toggleLeftDrawer,
  className,
  classes,
  ...props
}: Props): React.Node => {
  const handleIconClick = toggleRightDrawer;
  const siteInfo = useSiteInfo();
  return (
    <div className={classnames(classes.root, className)}>
      <Toolbar
        component={Container}
        className={classnames(classes.toolbar, className)}
        {...props}
      >
        <div className={classes.wrapper}>
          <Typography variant="h6">Origen Studio</Typography>
          <Hidden xsDown implementation="css">
            <div className={classes.actions}>
              {map(siteInfo?.data?.appbar_actions, (action, index: number) =>
                action && action.action_label && action.action_label.text ? (
                  <Button
                    key={index}
                    component={FieldLink}
                    field={action.action_link}
                    className={classes.link}
                  >
                    {action.action_label?.text}
                  </Button>
                ) : null,
              )}
            </div>
          </Hidden>
          <Hidden smUp implementation="css">
            <IconButton
              disableRipple
              aria-label="Menu Icon"
              onClick={handleIconClick}
              className={classes.menuIconButton}
            >
              <MenuIcon className={classes.menuIcon} />
            </IconButton>
          </Hidden>
        </div>
      </Toolbar>
    </div>
  );
};

AppBar.defaultProps = {
  className: undefined,
};

export default withStyles<*, *, Props>(styles)(AppBar);
